import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { Badge } from './ui/badge';
import { Button } from './ui/button';

const ProjectCard = ({ project }) => {
  const navigate = useNavigate();

  const statusColors = {
    'In R&D': 'bg-[#7C3AED]/20 text-[#7C3AED] border-[#7C3AED]/30',
    'In Validation': 'bg-[#14B8A6]/20 text-[#14B8A6] border-[#14B8A6]/30',
    'Commercial': 'bg-[#10B981]/20 text-[#10B981] border-[#10B981]/30',
    'Vision': 'bg-[#8B5CF6]/20 text-[#8B5CF6] border-[#8B5CF6]/30',
  };

  return (
    <div
      className="group relative bg-[#1F2A3A]/30 backdrop-blur-sm rounded-2xl p-6 border border-[#1F2A3A] hover:border-[#7C3AED]/50 transition-all duration-300 hover:shadow-2xl hover:shadow-[#7C3AED]/10 cursor-pointer"
      onClick={() => navigate(project.path)}
    >
      {/* Icon */}
      <div
        className="w-16 h-16 rounded-xl mb-4 flex items-center justify-center transition-transform duration-300 group-hover:scale-110"
        style={{
          background: `linear-gradient(135deg, ${project.color}33 0%, ${project.color}66 100%)`,
        }}
      >
        <project.icon size={32} style={{ color: project.color }} />
      </div>

      {/* Status Badge */}
      <Badge className={`mb-3 ${statusColors[project.status]}`}>
        {project.status}
      </Badge>

      {/* Title */}
      <h3 className="text-xl font-semibold text-white mb-2 group-hover:text-[#7C3AED] transition-colors">
        {project.title}
      </h3>

      {/* Description */}
      <p className="text-[#8A90A0] text-sm mb-4 leading-relaxed line-clamp-3">
        {project.description}
      </p>

      {/* CTA */}
      <Button
        variant="ghost"
        className="w-full justify-between text-[#7C3AED] hover:bg-[#7C3AED]/10 transition-colors"
      >
        View Project
        <ArrowRight size={18} className="group-hover:translate-x-1 transition-transform" />
      </Button>

      {/* Hover glow effect */}
      <div
        className="absolute inset-0 rounded-2xl opacity-0 group-hover:opacity-100 transition-opacity duration-300 pointer-events-none"
        style={{
          background: `radial-gradient(circle at 50% 50%, ${project.color}15 0%, transparent 70%)`,
        }}
      />
    </div>
  );
};

export default ProjectCard;